import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SiteRatingComponent } from './site-rating/site-rating.component';

import { OverlayModule } from '@angular/cdk/overlay';

import { BreadCrumbComponent } from './bread-crumb/bread-crumb.component';
import { RouterModule } from '@angular/router';
import { SitePopupInfoWidgetComponent } from './site-popup-info-widget/site-popup-info-widget.component';
import { FavouriteIconComponent } from './favourite-icon/favourite-icon.component';
import { CookiesService } from '../CookieService';
import { HeroBannerComponent } from './hero-banner/hero-banner.component';
import { LastUpdatedWidgetComponent } from './last-updated-widget/last-updated-widget.component';

import { ReactiveFormsModule } from '@angular/forms';

import { WaterTemperatureChartComponent } from './water-temperature-chart/water-temperature-chart.component';
import { GoogleChartsModule } from './google-charts/google-charts.module';
import { CustomDateWidgetComponent } from './custom-date-widget/custom-date-widget.component';
import { YesNoDialogComponent } from './yes-no-dialog/yes-no-dialog.component';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { ExternalLinkComponent } from './external-link/external-link.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MenuContextualService } from './MenuContextualService';
import {MatTreeModule} from '@angular/material/tree';
import { UserFeedbackDialogComponent } from './user-feedback-dialog/user-feedback-dialog.component';
import { DialogService } from './CustomDialog/DialogService';
import { AppendTargetDirective } from './directives/append-target/append-target.directive';

import { ContentCardComponent } from './content-card/content-card.component';
import { AnnualGradeComponent } from './annual-grade/annual-grade.component';

import { ForecastKeyWidgetComponent } from './forecast-key-widget/forecast-key-widget.component';
import { SiteInfoWidgetComponent } from './site-info-widget/site-info-widget.component';
import { VerticalHighlightBarComponent } from './vertical-highlight-bar/vertical-highlight-bar.component';
import { CounterDirective } from './directives/counter.directive';
import { TabsComponent } from './tabs-widget/tabs/tabs.component';
import { TabComponent } from './tabs-widget/tab/tab.component';
import { LoaderComponent } from './loader/loader.component';

import { KeyPopupWidgetComponent } from './key-update-widgets/key-popup-widget/key-popup-widget.component';
import { KeyLatestResultPopupContentWidgetComponent  } from 
	'./key-update-widgets/key-latest-result-popup-content-widget/key-latest-result-popup-content-widget.component';
import { KeyAnnualGradePopupContentWidgetComponent } from 
	'./key-update-widgets/key-annual-grade-popup-content-widget/key-annual-grade-popup-content-widget.component';
import { KeyForecastPopupContentWidgetComponent } from 
	'./key-update-widgets/key-forecast-popup-content-widget/key-forecast-popup-content-widget.component';
import { KeySitetrendsPopupContentWidgetComponent } from 
	'./key-update-widgets/key-sitetrends-popup-content-widget/key-sitetrends-popup-content-widget.component';
import { KeyRainfallPopupContentWidgetComponent } from 
	'./key-update-widgets/key-rainfall-popup-content-widget/key-rainfall-popup-content-widget.component';
import { KeyWatertempPopupContentWidgetComponent } from 
	'./key-update-widgets/key-watertemp-popup-content-widget/key-watertemp-popup-content-widget.component';
import { A11yModule } from '@angular/cdk/a11y';
import { AccordionComponent } from './accordion/accordion.component';
import { ActiveTabDirective } from './tabs-widget/active-tab.directive';
import { ModalDialogComponent } from './custom-modal-dialog/modal-dialog/modal-dialog.component';
import { DialogModule } from '@angular/cdk/dialog';
import { UserFeedbackModalDialogComponent } from './custom-modal-dialog/user-feedback-modal-dialog/user-feedback-modal-dialog.component';
import { AngularVideoPlayerComponent } from './angular-video-player/angular-video-player.component';
import {MatSliderModule} from '@angular/material/slider';
import { KeyAnnualGradeTrendPopupContentWidgetComponent } from './key-update-widgets/key-annual-grade-trend-popup-content-widget/key-annual-grade-trend-popup-content-widget.component';


@NgModule({
	declarations: [		
		BreadCrumbComponent,
		ContentCardComponent,
		SitePopupInfoWidgetComponent,		
		LastUpdatedWidgetComponent,
		SiteRatingComponent,		
		FavouriteIconComponent,
		HeroBannerComponent,		
		WaterTemperatureChartComponent,
 		CustomDateWidgetComponent,
  		YesNoDialogComponent,
    	ExternalLinkComponent,
		UserFeedbackDialogComponent, 
		AppendTargetDirective, 				
		AnnualGradeComponent, 		
		ForecastKeyWidgetComponent, 
		SiteInfoWidgetComponent,
		VerticalHighlightBarComponent,
  		CounterDirective,
		TabsComponent,
		TabComponent,
		LoaderComponent,
		KeyPopupWidgetComponent,
		KeyLatestResultPopupContentWidgetComponent,
		KeyAnnualGradePopupContentWidgetComponent, 		
		KeyForecastPopupContentWidgetComponent, 
 		KeySitetrendsPopupContentWidgetComponent,
   		KeyRainfallPopupContentWidgetComponent,
		KeyWatertempPopupContentWidgetComponent,
  		AccordionComponent,
    	ActiveTabDirective,
     	ModalDialogComponent,
     	UserFeedbackModalDialogComponent,
     	AngularVideoPlayerComponent,
      	KeyAnnualGradeTrendPopupContentWidgetComponent       
	],
	imports: [
		CommonModule,
		RouterModule,
		OverlayModule,
		ReactiveFormsModule,
		GoogleChartsModule,
		MatDialogModule,
		GoogleMapsModule,
		MatDialogModule,
		MatTreeModule,
		A11yModule,
		DialogModule,
		MatSliderModule
	],
	exports: [
		BreadCrumbComponent,
		ContentCardComponent,
		LastUpdatedWidgetComponent,
		SitePopupInfoWidgetComponent,		
		SiteRatingComponent,		
		FavouriteIconComponent,
		HeroBannerComponent,		
		WaterTemperatureChartComponent,
    	ExternalLinkComponent,
		UserFeedbackDialogComponent,
		CustomDateWidgetComponent,				
		AnnualGradeComponent,
		ForecastKeyWidgetComponent,
		SiteInfoWidgetComponent,
		VerticalHighlightBarComponent,
		CounterDirective,
		TabsComponent,
		TabComponent, 
		LoaderComponent,
		KeyPopupWidgetComponent,
		KeyLatestResultPopupContentWidgetComponent,
		KeyAnnualGradePopupContentWidgetComponent, 		
		KeyForecastPopupContentWidgetComponent, 	
		KeySitetrendsPopupContentWidgetComponent,
		KeyRainfallPopupContentWidgetComponent,
		KeyWatertempPopupContentWidgetComponent,
		AccordionComponent,
		ActiveTabDirective,
		UserFeedbackModalDialogComponent,
		ModalDialogComponent,
		AngularVideoPlayerComponent,
		KeyAnnualGradeTrendPopupContentWidgetComponent 
	],
	providers : [
		CookiesService,		
		MenuContextualService,
		{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false} },		
		DialogService,
		UserFeedbackModalDialogComponent
	],
	entryComponents:[UserFeedbackDialogComponent]
})
export class SharedCompsModule { }
